import { Directive, TemplateRef } from '@angular/core';

@Directive({
    selector: '[ngbTabContent]',
    standalone: false
})
export class NgbTabContentDirective {
  constructor(public templateRef: TemplateRef<any>) {}
}


@Directive({
    selector: '[ngbTabTitle]',
    standalone: false
})
export class NgbTabTitleDirective {
  constructor(public templateRef: TemplateRef<any>) {}
}